module.exports = __webpack_public_path__ + "media/play_event_moose-remove.fd439c51.mp3";